import {
  AuditTrailAccountTable,
  AuditTrailItem,
  AuditTrailItemData,
  VatDeclarationAuditTrailData,
} from '../elements/VatDeclaration/elements/VatDeclarationReport/elements/AuditTrail/types/AuditTrail'
import { formatReportNumber } from './formatReportNumber'
import { toTransactionOriginatorType } from './formatTransactionType'

interface ParseSingleTableDataParams {
  data: AuditTrailItemData
  locale: string
}

const parseSingleTableData = ({ data, locale }: ParseSingleTableDataParams): AuditTrailItem => {
  /* eslint-disable @typescript-eslint/naming-convention */
  const {
    abbreviation,
    amount: amountValue,
    entry_date,
    is_voided,
    net_amount,
    originator_id,
    originator_name,
    originator_type,
    running_total,
    tax_rate,
    transaction_id,
    transaction_no,
    voucher_no,
  } = data
  /* eslint-enable @typescript-eslint/naming-convention */
  const rate = tax_rate !== undefined ? `${tax_rate * 100}%` : '0%'

  const netAmount = formatReportNumber({ number: net_amount, locale })
  const balance = formatReportNumber({ number: running_total, locale })
  const amount = formatReportNumber({ number: amountValue, locale })

  return {
    abbreviation,
    amount,
    balance,
    date: entry_date,
    description: originator_name,
    id: originator_id,
    isVoided: is_voided,
    netAmount,
    rate,
    transaction: transaction_no,
    transactionId: transaction_id,
    voucher: voucher_no,
    type: toTransactionOriginatorType(originator_type),
  }
}

interface FormatSeparateReportsParams {
  data?: VatDeclarationAuditTrailData
  locale: string
}

export const formatAuditTrailSubreports = ({ data, locale }: FormatSeparateReportsParams): AuditTrailAccountTable[] => {
  if (!data || !data.items) {
    return []
  }

  return data.items.map((subtable) => {
    const mainData = subtable.items.map((item) => parseSingleTableData({ data: item, locale }))

    const balance = formatReportNumber({ number: subtable.balance, locale, withDigits: false })

    return { mainData, tableName: subtable.label, total: balance, type: subtable.type }
  })
}
